var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg3Mobile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 524,
    viewBox: "0 0 360 524",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_447_110338)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294,
    cy: 758,
    r: 463.5,
    fill: "url(#paint0_linear_447_110338)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_447_110338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393 270.5L760.628 907.25H25.3722L393 270.5Z",
    fill: "url(#paint1_linear_447_110338)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_447_110338",
    x: -469.5,
    y: -5.5,
    width: 1527,
    height: 1527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_447_110338"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_447_110338",
    x: -244.625,
    y: 0.5,
    width: 1275.25,
    height: 1176.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 135,
    result: "effect1_foregroundBlur_447_110338"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_447_110338",
    x1: 153.324,
    y1: 422.979,
    x2: 408,
    y2: 884.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37E2D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_447_110338",
    x1: 393,
    y1: 270.5,
    x2: 393,
    y2: 1119.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3Mobile);
export default __webpack_public_path__ + "static/media/bg3-mobile.94a1655bb1c70b30b1dc3f18a4ffa8d5.svg";
export { ForwardRef as ReactComponent };